import postscribe from 'postscribe'
import axios from '@/plugins/axios'

export default {
  cardToken: true,
  init (token) {
    const element = document.getElementById('payments')
    return new Promise((resolve, reject) => {
      const callback = {
        done: function () {
          axios.get('/payment/mercadopago/public/' + token).then((response) => {
            window.Mercadopago.setPublishableKey(response.data.public_key)
            resolve()
          }).catch((error) => {
            reject(error)
          })
        },
        error: function (response) {
          // Callback para chamadas que falharam.
          reject(response)
        }
      }
      postscribe(element, '<script src="https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js"></script>', callback)
    })
  },
  getInstallments (card) {
    return new Promise((resolve, reject) => {
      const setInstallments = function (status, response) {
        const method = response[0]
        const installments = []
        method.payer_costs.forEach(element => {
          installments.push({
            value: element.installments,
            text: element.recommended_message
          })
        })
        resolve({
          payment_method_id: method.payment_method_id,
          installments: installments
        })
      }
      const installments = function (status, response) {
        window.Mercadopago.getInstallments({
          payment_method_id: response[0].id,
          amount: parseFloat(card.total_price),
          issuer_id: undefined
        }, setInstallments)
      }
      window.Mercadopago.getPaymentMethod({
        bin: card.number.replace(/\D/g, '')
      }, installments)
    })
  }

}
